<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["DonemId", "IcKontrolDonemId", "Donemler"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
    },
    methods: {
        Get() {
            let Filter = "&DonemId=" + this.IcKontrolDonemId + "&UstDonemId=" + this.DonemId;
            this.ActionsFilterGet({ Service: "StrRaporlama/GetSoruFormuKurumBazli", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data.AnaGruplar;
                for (var Donem in this.Donemler) {
                    if (this.Donemler[Donem].Id == this.IcKontrolDonemId) {
                        this.DonemAdi = this.Donemler[Donem].Aciklama
                    }
                }


            });

        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
        toplamlar(Data){
            var toplam = 0;
            for(var SubData in Data){
                for(var Eylem in Data[SubData].Eylemler){
                    toplam += Data[SubData].Eylemler[Eylem].Puan
                }
            }
            return toplam;
        },
        tampuan(Data){
            var toplam = 0;
            for(var SubData in Data){
                for(var Eylem in Data[SubData].Eylemler){
                    toplam += (Data[SubData].Eylemler[Eylem].BirimSayisi)*2
                }
            }
            return toplam;
        },
        gerceklesmeyüzdesi(Data){
            var result = 0; 
            if(Data){
                var tampuan = this.tampuan(Data)
                var toplamlar = this.toplamlar(Data)
                result = (toplamlar*100)/tampuan
            }            
            return result.toFixed(2);
        }
    },
    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'Soru Formu Sonuçları (Kurum Bazlı)',
                        'Soru Formu Sonuçları (Kurum Bazlı)',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="8" class="h5"
                                style="text-align: center;border-color: #0049B7; border-style: solid; font-family: Arial; display: block;">
                                Soru Formu Sonuçları (Kurum Bazlı) <br>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive" v-for="(Data, index) in TableData" :key="index">
                                    <div v-if="Data.Tanimlar.length > 0 && Data.Tanimlar[0].Eylemler.length > 0 ">
                                    <table class="table table-striped table-bordered mb-0">
                                        <thead>
                                            <tr style="background-color: #0049B7;">
                                                <th colspan="8" class="col-md-12">{{ Data.AnaGrupValue }}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div v-for="(Tanim, index) in Data.Tanimlar" :key="index">
                                    <table class="table table-striped table-bordered mb-0" v-if="Tanim.Eylemler.length > 0">
                                        <thead>
                                            <tr style="background-color: #00ACB7;">
                                                <th colspan="4" class="col-md-6">{{ Tanim.StandartValue }}</th>
                                                <th colspan="4" style="text-align: center;">{{ DonemAdi }}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(Eylemler, index) in Tanim.Eylemler" :key="index">
                                            <tr>
                                                <td colspan="4" class="col-md-6">{{ Eylemler.EylemValue }}</td>
                                                <td colspan="4" style="text-align: center;">{{ Eylemler.Puan }}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                    <table class="table table-striped table-bordered mb-0">
                                        <tbody>
                                            <tr>
                                                <th colspan="4" class="col-md-6">Toplam Puan</th>
                                                <td colspan="4" style="text-align: center;">{{ toplamlar(Data.Tanimlar)}}</td>
                                            </tr>
                                            <tr>
                                                <th class="col-md-6" colspan="4">Bütün Eylemlerin Tamamlanması Sonucu Alınacak Puan</th>
                                                <td colspan="4" style="text-align: center;">{{ tampuan(Data.Tanimlar) }}</td>
                                            </tr>
                                            <tr>
                                                <th class="col-md-6" colspan="4">Gerçekleşme Yüzdesi</th>
                                                <td colspan="4" style="text-align: center;">%{{ gerceklesmeyüzdesi(Data.Tanimlar) }}</td>
                                            </tr> 

                                        </tbody>
                                    </table>
                                    <br /><br />
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </Loader>
</template>
